import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from 'formbird-services';
import {SclCsvParserHandlerService} from './scl-csv-parser-handler.service';
import {SclCsvParserService} from './scl-csv-parser.service';

const sclCsvParserHandler = new SclCsvParserHandlerService();
const sclCsvParser = new SclCsvParserService();

@Injectable({
  providedIn: 'root'
})
export class SclUtilImporterService {
  notificationService: any;
  dataService: any;
  componentScope: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
  }

  DEFAULTS = {
    delimiter: '',	// empty: auto-detect
    newline: '',	// empty: auto-detect
    header: false,
    dynamicTyping: false,
    preview: 0,
    step: undefined,
    comments: false,
    complete: undefined,
    skipEmptyLines: false,
    fastMode: false
  };
  reIsHostCtor = /^\[object .+?Constructor\]$/;
  reIsUint = /^\d+$/;
  MAX_SAFE_INTEGER = 9007199254740991;

  reIsNative = RegExp('^' +
    Function.prototype.toString.call(Object.prototype.hasOwnProperty)
      .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/Object.prototype.hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$')
  ;

  arrayTag = '[object Array]';
  rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
  reEscapeChar = /\\(\\)?/g;
  reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/;
  reIsPlainProp = /^\w*$/;
  docIdMatch = '';
  docIdNoMatch = '';

  isObjectLike(value) {
    return !!value && typeof value === 'object';
  }

  isLength(value) {
    return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= this.MAX_SAFE_INTEGER;
  }

  isFunction(func) {
    return typeof func === 'function';
  }

  isNative(value) {
    const fnToString = Function.prototype.toString;
    if (value == null) {
      return false;
    }
    if (this.isFunction(value)) {
      return this.reIsNative.test(fnToString.call(value));
    }
    return this.isObjectLike(value) && this.reIsHostCtor.test(value);
  }

  getNative(object, key) {
    const value = object == null ? undefined : object[key];
    return this.isNative(value) ? value : undefined;
  }

  isArray(value) {
    const nativeIsArray = this.getNative(Array, 'isArray');
    const objToString = Object.prototype.toString;

    if (!value) {
      return nativeIsArray;
    }

    return this.isObjectLike(value) && this.isLength(value.length) && objToString.call(value) === this.arrayTag;
  }

  isObject(value) {
    const type = typeof value;
    return !!value && (type === 'object' || type === 'function');
  }

  isIndex(value?, length?) {
    value = (typeof value === 'number' || this.reIsUint.test(value)) ? +value : -1;
    length = length == null ? this.MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 === 0 && value < length;
  }

  baseToString(value) {
    return value == null ? '' : (value + '');
  }


  toPath(value) {
    if (this.isArray(value)) {
      return value;
    }
    const result = [];
    // @ts-ignore
    this.baseToString(value).replace(this.rePropName, function (match, number, quote, string) {
      result.push(quote ? string.replace(this.reEscapeChar, '$1') : (number || match));
    });
    return result;
  }

  toObject(value) {
    return this.isObject(value) ? value : Object(value);
  }


  isKey(value, object) {
    const type = typeof value;
    if ((type === 'string' && this.reIsPlainProp.test(value)) || type === 'number') {
      return true;
    }
    if (this.isArray(value)) {
      return false;
    }
    const result = !this.reIsDeepProp.test(value);
    return result || (object != null && value in this.toObject(object));
  }

  set(object, path, value) {
    if (object == null) {
      return object;
    }

    if (path === 'date' && value === '') {
      // value = undefined;
    }

    const pathKey = (path + '');
    path = (object[pathKey] != null || this.isKey(path, object)) ? [pathKey] : this.toPath(path);

    let index = -1;
    const length = path.length;
    const lastIndex = length - 1;
    let nested = object;

    while (nested != null && ++index < length) {
      const key = path[index];
      if (this.isObject(nested)) {
        if (index === lastIndex) {
          nested[key] = value;
        } else if (nested[key] == null) {
          nested[key] = this.isIndex(path[index + 1]) ? [] : {};
        }
      }
      nested = nested[key];
    }
    return object;
  }

  validateColumnHeader(dataObject, columnsLabels) {
    let isHeader = true;
    if (dataObject.length > 0 && columnsLabels && dataObject[0].length === columnsLabels.length) {
      for (let i = 0; i < dataObject[0].length; i++) {
        if (dataObject[0][i] !== columnsLabels[i]) {
          isHeader = false;
          break;
        }
      }
    } else {
      isHeader = false;
    }

    return isHeader;
  }


  processDocumentIdMatch(newDoc, oldDoc, docIdMatch) {
    if (docIdMatch === 'merge') {
      for (const key in newDoc) {
        if (key !== 'documentId' && key !== 'systemHeader' && newDoc.hasOwnProperty(key)) {
          if (oldDoc[key] instanceof Array && newDoc[key] instanceof Array) {
            let dataObj = [];
            dataObj = dataObj.concat(oldDoc[key]);
            dataObj = dataObj.concat(newDoc[key]);
            oldDoc[key] = dataObj;
          } else if (oldDoc[key] instanceof Object && newDoc[key] instanceof Object) {
            const dataObj = {};
            for (const attr in oldDoc[key]) {
              if (oldDoc[key][attr]) {
                dataObj[attr] = oldDoc[key][attr];
              }
            }
            for (const attr in newDoc[key]) {
              if (newDoc[key][attr]) {
                dataObj[attr] = newDoc[key][attr];
              }
            }
            oldDoc[key] = dataObj;
          } else {
            oldDoc[key] = newDoc[key];
          }
        }
      }
      return oldDoc;
    } else if (docIdMatch === 'replace') {
      newDoc.systemHeader = oldDoc.systemHeader;
      return newDoc;
    }
  }

  processDocumentIdNoMatch(newDoc, docIdNoMatch) {
    if (docIdNoMatch === 'add') {
      return newDoc;
    } else if (this.docIdNoMatch === 'error') {
      const errMsg = 'documentId \'' + newDoc.documentId + '\' is not in database and adding is not enabled';
      newDoc.errMsg = errMsg;
      return newDoc;
    }
  }

  setComponentScopeData(compScope) {
    this.componentScope = compScope;
  }

  getComponentScope() {
    return this.componentScope;
  }


  processInsertDocIdNoMatch(document, csvIndex, docIdNoMatch) {
    const self = this;
    document = this.processDocumentIdNoMatch(document, docIdNoMatch);
    if (docIdNoMatch === 'add') {
      this.dataService.insert(document).then(
        function successFunc(data) {
          console.log(data, 'return');
          self.insertSuccess(data, csvIndex);
        },
        function errorFunc(err) {
          self.insertFail(err, csvIndex);
        });
    } else if (docIdNoMatch === 'error') {
      this.insertFail(document.errMsg, csvIndex);
    }
  }

  insertSuccess(data?, csvIdx?, actionName?) {
    actionName = (actionName ? actionName : 'Imported');
    this.notificationService.success(data.documentId + ' ' + actionName + '!');
    // logger.info(data.documentId + ' ' + actionName + '!');
    this.componentScope.tempDocId = data.documentId;
    this.componentScope.documentCreated++;
    this.componentScope.items[csvIdx].result = actionName + ' - ' + data.documentId;
    this.componentScope.items[csvIdx].documentId = data.documentId;
    this.componentScope.items[csvIdx][this.componentScope.componentDefinition.csvFieldNamePrefix +
    this.componentScope.getIndexOfDocumentIdInColumnLabels()] = data.documentId;
      // Update itemsMatTableData for mat-table display
    this.componentScope.itemsMatTableData[csvIdx].result = actionName + ' - ' + data.documentId;
    this.componentScope.itemsMatTableData[csvIdx].documentId = data.documentId;
    this.componentScope.itemsMatTableData[csvIdx]['colData' + this.componentScope.getIndexOfDocumentIdInColumnLabels()] = data.documentId;
    this.componentScope.loadItemsToDataTable(this.componentScope.itemsMatTableData);
  }

  insertFail(err?, csvIdx?, actionName?) {
    let errMsg = '';
    if (actionName) {
      actionName = (actionName === 'Updated' ? 'updating' : 'replacing');
      errMsg = 'Failed - ' + err.message.replace('updating', actionName);
    } else {
      errMsg = 'Failed - ' + err.message;
    }
    this.notificationService.error(errMsg);
    // logger.info(errMsg);
    this.componentScope.errors++;
    this.componentScope.items[csvIdx].result = errMsg;
    this.componentScope.itemsMatTableData[csvIdx].result = errMsg;
    this.componentScope.loadItemsToDataTable(this.componentScope.itemsMatTableData);
  }

  isRowData(rowData) {
    let hasData = false;
    for (let i = 0; i < rowData.length; i++) {
      if (rowData[i] !== '') {
        hasData = true;
        break;
      }
    }
    return hasData;
  }

  isRowDataObj(rowData) {
    let hasData = false;
    for (const key in rowData) {
      if (rowData[key] !== '') {
        hasData = true;
        break;
      }
    }
    return hasData;
  }

  copy(obj) {
    if (typeof obj !== 'object') {
      return obj;
    }
    const cpy = obj instanceof Array ? [] : {};
    for (const key in obj) {
      if (obj[key]) {
        cpy[key] = this.copy(obj[key]);
      }
    }

    return cpy;
  }

  copyAndValidateConfig(origConfig) {
    const Baby = sclCsvParser.getBaby();

    if (typeof origConfig !== 'object') {
      origConfig = {};
    }

    const config = this.copy(origConfig);

    if (typeof config.delimiter !== 'string'
      || config.delimiter.length !== 1
      || Baby.BAD_DELIMITERS.indexOf(config.delimiter) > -1) {
      config.delimiter = this.DEFAULTS.delimiter;
    }

    if (config.newline !== '\n'
      && config.newline !== '\r'
      && config.newline !== '\r\n') {
      config.newline = this.DEFAULTS.newline;
    }

    if (typeof config.header !== 'boolean') {
      config.header = this.DEFAULTS.header;
    }

    if (typeof config.dynamicTyping !== 'boolean') {
      config.dynamicTyping = this.DEFAULTS.dynamicTyping;
    }

    if (typeof config.preview !== 'number') {
      config.preview = this.DEFAULTS.preview;
    }

    if (typeof config.step !== 'function') {
      config.step = this.DEFAULTS.step;
    }

    if (typeof config.complete !== 'function') {
      config.complete = this.DEFAULTS.complete;
    }

    if (typeof config.skipEmptyLines !== 'boolean') {
      config.skipEmptyLines = this.DEFAULTS.skipEmptyLines;
    }

    if (typeof config.fastMode !== 'boolean') {
      config.fastMode = this.DEFAULTS.fastMode;
    }

    return config;
  }

  CsvToJson(_INPUT, _CONFIG) {
    const config = this.copyAndValidateConfig(_CONFIG);
    const ph = new sclCsvParserHandler.ParserHandle(config);
    const results = ph.parse(_INPUT);
    if (this.isFunction(config.complete)) {
      config.complete(results);
    }
    return results;
  }

}

